var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAudio = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.516V8.28c0-.58.39-1.054.947-1.195l6.82-1.823a.782.782 0 0 1 .983.753v.86",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 11.559v3.125c0 .543-.349 1-.86 1.171l-.859.313c-1.011.34-2.031-.407-2.031-1.484a1.304 1.304 0 0 1 .898-1.25l1.993-.71c.51-.171.859-.622.859-1.165Zm0 0V2.264a.392.392 0 0 0-.492-.375l-7.79 2.094a.644.644 0 0 0-.468.625v8.828c0 .543-.349 1-.86 1.172l-2.03.703c-.543.183-.86.672-.86 1.25 0 1.077 1.036 1.818 2.031 1.484l.86-.312c.51-.172.859-.628.859-1.172v-3.125",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAudio as ReactComponent };